module.exports = __webpack_public_path__ + "img/part-brigadeiro.43a3f9e0.svg";